export var Mode;
(function (Mode) {
    Mode["SOQL"] = "Soql";
    Mode["VIF"] = "Vif";
    Mode["CATALOG"] = "Catalog";
    Mode["METADATA"] = "Metadata";
    Mode["OMNI"] = "Omni";
})(Mode || (Mode = {}));
export var RenderMode;
(function (RenderMode) {
    RenderMode["FLOATING"] = "floating";
    RenderMode["FULL_SCREEN"] = "full_screen";
    RenderMode["FIXED"] = "fixed";
})(RenderMode || (RenderMode = {}));
export const isSoql = (mode) => {
    return mode === Mode.SOQL;
};
export const isVif = (mode) => {
    return mode === Mode.VIF;
};
export const isCatalog = (mode) => {
    return mode === Mode.CATALOG;
};
export const isMetadata = (mode) => {
    return mode === Mode.METADATA;
};
export const isOmni = (mode) => {
    return mode === Mode.OMNI;
};
export var ProxyApp;
(function (ProxyApp) {
    ProxyApp["FRONTEND"] = "frontend";
    ProxyApp["STORYTELLER"] = "storyteller";
})(ProxyApp || (ProxyApp = {}));
export const isFrontend = (proxyApp) => {
    return proxyApp === ProxyApp.FRONTEND;
};
export const isStoryteller = (proxyApp) => {
    return proxyApp === ProxyApp.STORYTELLER;
};
export var AgentContextName;
(function (AgentContextName) {
    AgentContextName["SOQL"] = "soql_agent";
    AgentContextName["VIF"] = "visualization_agent";
    AgentContextName["CATALOG"] = "catalog_agent";
    AgentContextName["OMNI"] = "omni_agent";
})(AgentContextName || (AgentContextName = {}));
const isAppContextDatasetFields = (externalAppContext) => {
    const missingFields = [];
    if (typeof externalAppContext.domainName !== 'string') {
        missingFields.push('domainName');
    }
    if (typeof externalAppContext.datasetName !== 'string') {
        missingFields.push('datasetName');
    }
    if (typeof externalAppContext.datasetId !== 'string') {
        missingFields.push('datasetId');
    }
    if (!Array.isArray(externalAppContext.sampleData)) {
        missingFields.push('sampleData');
    }
    if (!Array.isArray(externalAppContext.schema)) {
        missingFields.push('schema');
    }
    if (typeof externalAppContext.datasetOwnerName !== 'string') {
        missingFields.push('datasetOwnerName');
    }
    if (typeof externalAppContext.datasetCreatedAt !== 'string') {
        missingFields.push('datasetCreatedAt');
    }
    if (typeof externalAppContext.datasetUpdatedAt !== 'string') {
        missingFields.push('datasetUpdatedAt');
    }
    if (typeof externalAppContext.viewCount !== 'number') {
        missingFields.push('viewCount');
    }
    if (externalAppContext.commonQuestions && !Array.isArray(externalAppContext.commonQuestions)) {
        missingFields.push('commonQuestions');
    }
    if (missingFields.length > 0) {
        throw new Error(`Missing App Context Fields: ${missingFields.join(', ')}`);
    }
    return true;
};
export const convertFromExternalAppContextToInternal = (externalAppContext, mode) => {
    try {
        if (isSoql(mode) || isVif(mode)) {
            if (isAppContextDatasetFields(externalAppContext)) {
                return Object.assign(Object.assign({}, externalAppContext), { name: isSoql(mode) ? AgentContextName.SOQL : AgentContextName.VIF, mode: isSoql(mode) ? Mode.SOQL : Mode.VIF });
            }
        }
        if ('domainName' in externalAppContext) {
            if (isCatalog(mode)) {
                return Object.assign(Object.assign({}, externalAppContext), { name: AgentContextName.CATALOG, mode: Mode.CATALOG });
            }
            else {
                return Object.assign(Object.assign({}, externalAppContext), { name: AgentContextName.OMNI, mode: Mode.OMNI });
            }
        }
        throw new Error('Missing App Context Fields: domainName');
    }
    catch (error) {
        throw new Error(`Required fields are missing in the app context prop. The chatbot component can't start. ${error.message}`);
    }
};
export var ActionFunctionTypes;
(function (ActionFunctionTypes) {
    ActionFunctionTypes["VIF"] = "generateVifFunction";
    ActionFunctionTypes["OMNI"] = "updateSelectedDatasetId";
})(ActionFunctionTypes || (ActionFunctionTypes = {}));
export const convertFromActionFunctionConfigToProps = (actionFunctionConfig) => {
    switch (actionFunctionConfig.functionType) {
        case ActionFunctionTypes.VIF:
            if (!actionFunctionConfig.vif ||
                typeof actionFunctionConfig.vif !== 'object' ||
                typeof actionFunctionConfig.type !== 'string' ||
                typeof actionFunctionConfig.vifActionType !== 'string') {
                return false;
            }
            return true;
        case ActionFunctionTypes.OMNI:
            return typeof actionFunctionConfig.selectedDatasetId === 'string';
        default:
            return false;
    }
};
//# sourceMappingURL=types.js.map